import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum ResetOrderErrorCodes {
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND",
  ORDER_ALREADY_HAS_RETURN = "ORDER_ALREADY_HAS_RETURN",
  UNAUTHORIZED = "UNAUTHORIZED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

const resetOrderFlowInputSchema_ = z.object({
  orderId: z.string(),
  step: z.number().optional(),
  changeDefaultStep: z.boolean().optional(),
  userId: z.string().optional(),
  resetReason: z.string(),
  returnType: createEnum(ReturnTypeEnum),
  /** Restricts the preset to these line items; omit to set the whole order. */
  lineItemIds: z.array(z.string()).optional(),
});

export const resetOrderFlowInputSchema: z.ZodType<ResetOrderFlowInput> =
  resetOrderFlowInputSchema_;
export interface ResetOrderFlowInput extends z.infer<
  typeof resetOrderFlowInputSchema_
> {}

const resetOrderFlowOutputSchema_ = z.object({ success: z.boolean() });

export const resetOrderFlowOutputSchema: z.ZodType<ResetOrderFlowOutput> =
  resetOrderFlowOutputSchema_;
export interface ResetOrderFlowOutput extends z.infer<
  typeof resetOrderFlowOutputSchema_
> {}

export const resetOrderFlow = {
  name: "resetOrderFlow" as const,
  input: resetOrderFlowInputSchema,
  output: resetOrderFlowOutputSchema,
};
